import { Component, NgZone, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavController, ToastController } from '@ionic/angular';
import { GlobalVariable } from '../global';
import { ServerService } from '../providers/server.service';
declare var google;
@Component({
  selector: 'app-add-new-business',
  templateUrl: './add-new-business.page.html',
  styleUrls: ['./add-new-business.page.scss'],
})
export class AddNewBusinessPage implements OnInit {
  resform: FormGroup;
  submitAttempt: boolean = false;
  formatedPhone: string;
  autocompleteItems: any;
  autocomplete: any;
  temp: boolean = false;
  geo: any;
  addressSearch: boolean = false;
  service = new google.maps.places.AutocompleteService();
  items = [];
  lat: any;
  lng: any;
  constructor(
    public navCtrl: NavController,
    public formBilder: FormBuilder,
    public server: ServerService,
    public globals: GlobalVariable,
    public toastController: ToastController,
    public zone: NgZone
  ) {
    this.autocompleteItems = [];
    this.autocomplete = {
      query: '',
    };
    this.resform = formBilder.group({
      name: ['', Validators.compose([Validators.required])],
      address: ['', Validators.compose([Validators.required])],
      lat: [this.lat, Validators.compose([Validators.required])],
      lng: [this.lng, Validators.compose([Validators.required])],

      notes: ['', Validators.compose([])],
      email: ['', Validators.compose([])],
      phone: [, Validators.compose([])],
    });
    // localStorage.setItem("udid", this.data.response.udid);
    let udid = localStorage.getItem('udid');
    if (udid != null && udid != undefined) {
      this.globals.udid = udid;
    }
  }

  ngOnInit() {}
  numberChange() {
    console.log('here');
    this.formatedPhone = String(this.resform.value.phone);
    var cleaned = ('' + this.formatedPhone).replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      this.formatedPhone =
        '(' + match[1] + ') ' + (match[2] ? match[2] + '-' : '') + match[3];
      console.log(this.formatedPhone);
    }
    // var match = cleaned.match( /^(\d{3})(\d{3})(\d{4})$/)
    // if (match) {

    //     console.log('match')
    //   this.formatedPhone= '(' + match[1] + ') ' + match[2] + '-' + match[3]
    // }
    return null;
    // var clean = this.formatedPhone.replace(/[^\d]/g, '')
    // console.log(clean)
    // this.formatedPhone = clean.replace(/[0-9]{3}-[0-9]{3}-[0-9]{4}/g,'');
    // console.log(this.formatedPhone)
  }
  async submit() {
    var cleaned = ('' + this.resform.value.phone).replace(/\D/g, '');
    if (
      this.globals.udid != '' &&
      this.globals.udid != null &&
      this.globals.udid != undefined
    ) {
      if (!this.resform.valid) {
        console.log(
          ' Some values were not given or were incorrect, please fill them'
        );
        this.submitAttempt = true;
      } else {
        let toast = await this.toastController.create({
          message: 'Submitting your request..',
          color: 'warning',
          position: 'middle',
        });
        toast.present();
        this.server
          .addNewBusiness(
            this.resform.value.name,
            this.resform.value.address,
            this.resform.value.email,
            '+1' + cleaned,
            this.resform.value.notes,
            this.resform.value.lat,
            this.resform.value.lng
          )
          .subscribe(
            async (res) => {
              toast.dismiss();

              console.log(res);
              if (res.status == true) {
                // this.navCtrl.pop();
                this.navCtrl.navigateRoot('home');
                let toast2 = await this.toastController.create({
                  message: 'Your request submitted Successfully..',
                  duration: 2000,
                  color: 'primary',
                  position: 'middle',
                });
                toast2.present();
                // this.globals.presentToast(res.message);
              } else {
                this.globals.presentToast(res.message);
              }
            },
            (err) => {
              toast.dismiss();
              this.globals.presentToast(
                'failed to request',
                'Something went wrong while adding request for new business. try again later'
              );
            }
          );
        //api call
      }
    } else {
      this.globals.presentToast(
        "Not Logged in. You can contribute once you're logged in."
      );
    }
  }

  saveAddress() {
    // this.globals.address = this.autocomplete.query;
    this.addressSearch = false;
    this.autocompleteItems = [];
    // this.globals.dataNotLoaded=true;
    // this.resList=[];
    // this.hasData=true;
    // this.offset=0;
    // this.limit=20;
    // this.list();
  }
  editAddress() {
    this.addressSearch = true;
  }
  get errorControl() {
    return this.resform.controls;
  }
  dismiss() {
    this.temp = false;
    this.autocompleteItems = [];
  }
  // loadBanner() {
  //   let response = this.server.LoadBannersOnHomePage();
  //   response.subscribe((data) => {
  //     console.log(data);
  //   });
  // }

  cancelAddressSearch() {
    this.addressSearch = false;
  }
  chooseItem(item: any) {
    if (item == undefined || item == null) {
      this.globals.presentToast('Invalid address!');
      return;
    }
    this.autocomplete.query = item;
    this.geo = item;
    // this.globals.address = this.autocomplete.query;
    this.addressSearch = false;
    this.autocompleteItems = [];
    // this.globals.dataNotLoaded=true;
    // this.resList=[];
    // this.hasData=true;
    // this.offset=0;
    // this.limit=20;
    // this.list();
    // this.dismiss();
    this.geoCode(this.geo);
    console.log('item', item);
    console.log('geo', this.geo);
  }
  geoCode(address: any) {
    // let that = this;
    let geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: address }, (results, status) => {
      console.log('results ', results);
      this.lat = results[0].geometry.location.lat();
      this.lng = results[0].geometry.location.lng();
      this.resform.controls['lat'].setValue(this.lat);
      this.resform.controls['lng'].setValue(this.lng);
    });
  }
  updateSearch() {
    if (this.autocomplete.query == '') {
      console.log('if run');
      this.autocompleteItems = [];
      this.temp = false;
      return;
    } else if (this.autocomplete.query.length >= 3) {
      console.log('else if run');
      this.temp = true;
      let me = this;
      this.service.getPlacePredictions(
        {
          input: this.autocomplete.query,
          types: ['address'],
          componentRestrictions: {
            country: 'us',
          },
        },
        (predictions, status) => {
          me.autocompleteItems = [];

          me.zone.run(() => {
            if (predictions != null) {
              // console.log(predictions)
              predictions.forEach((prediction) => {
                me.autocompleteItems.push(prediction.description);
                // console.log(me.autocompleteItems);
              });
            }
          });
        }
      );
    } else {
      console.log('else run');
    }
  }
}
